@app.directive 'recover', (ModalService, AnalyticsService, $state, authenticationService, formHelper, alertService)->
  restrict: 'E'
  scope: {}
  controller: ($scope) ->

    @showErrorFor = (fieldName, validationParam) =>
      formHelper.showErrorFor(@form, fieldName, validationParam)

    @close = ->
      ModalService.reject()

    @submit = =>

      recoverSuccess = =>
        AnalyticsService.track 'Modal Recover Submit Success', {url: $state.current.url}
        # $rootScope.$emit 'New Alert', {type: 'success', message: 'Please check your email for password recovery instructions.'}

        @showSpinner = false
        ModalService.resolve()
        if $state.current.name == 'passwordReset'
          alertService.addAlert {type: 'success', message: 'Please check your email for password recovery instructions.'}
          $state.go 'main.home'

      recoverError = =>
        AnalyticsService.track 'Modal Recover Submit Error', {url: $state.current.url}
        # $rootScope.$emit 'New Alert', {type: 'error', message: 'An error occured while registering your account.'}
        @showSpinner = false

      if @form.$valid
        AnalyticsService.track 'Modal Recover Form Submitted', {url: $state.current.url}
        @showSpinner = true

        authenticationService
          .recover @form.email.$modelValue
          .then recoverSuccess, recoverError

    @signup = ->
      signupSuccess = ->
        console.log 'Resolved signup'

      signupError = ->
        console.log 'Rejected signup'

      ModalService.open('signup', ModalService.modal.params).then signupSuccess, signupError
    this

  controllerAs: 'recover'
  templateUrl: "/assets/templates/modals/recover/recover.html"
